// extracted by mini-css-extract-plugin
export default {"newsList":"newslist_newsList__kcWwr","secondary":"newslist_secondary__fJqWM"};